import { SubjectDetailPage } from "@/features/learning-content/pages/SubjectDetail";
import { Box, Stack } from "@mui/material";
import { FC } from "react";

const SubjectDetail: FC = () => {
  return (
    <Stack sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <SubjectDetailPage />
      </Box>
    </Stack>
  );
};

export default SubjectDetail;
